import { IconPropsType } from './types/IconsProps.type';

type SearchDocumentIconProps = IconPropsType;

export const SearchDocumentIcon = ({
  width = 40,
  height = 40,
  className = '',
  style = {},
  fillColor = 'currentColor',
}: SearchDocumentIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M8.33333 8.33317H11.6667V13.3332H28.3333V8.33317H31.6667V16.6665H35V8.33317C35 6.49984 33.5 4.99984 31.6667 4.99984H24.7C24 3.0665 22.1667 1.6665 20 1.6665C17.8333 1.6665 16 3.0665 15.3 4.99984H8.33333C6.5 4.99984 5 6.49984 5 8.33317V31.6665C5 33.4998 6.5 34.9998 8.33333 34.9998H16.6667V31.6665H8.33333V8.33317ZM20 4.99984C20.9167 4.99984 21.6667 5.74984 21.6667 6.6665C21.6667 7.58317 20.9167 8.33317 20 8.33317C19.0833 8.33317 18.3333 7.58317 18.3333 6.6665C18.3333 5.74984 19.0833 4.99984 20 4.99984Z"
        fill={fillColor}
      />
      <path
        d="M33.8333 31.5C34.5 30.3333 35 29 35 27.5C35 23.3333 31.6667 20 27.5 20C23.3333 20 20 23.3333 20 27.5C20 31.6667 23.3333 35 27.5 35C29 35 30.3333 34.5 31.5 33.8333L36 38.3333L38.3333 36L33.8333 31.5ZM27.5 31.6667C25.1667 31.6667 23.3333 29.8333 23.3333 27.5C23.3333 25.1667 25.1667 23.3333 27.5 23.3333C29.8333 23.3333 31.6667 25.1667 31.6667 27.5C31.6667 29.8333 29.8333 31.6667 27.5 31.6667Z"
        fill={fillColor}
      />
    </svg>
  );
};
